import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import {
  DataObject,
  getMonthsBetweenDates,
  returnDateString,
} from "Pages/Faculties/FacultiesMain";
import FacultiesRegionsHeader from "Pages/FacultiesAntd/Regions/FacultiesRegionsHeader";
import FacultiesRegionsTable from "Pages/FacultiesAntd/Regions/FacultiesRegionsTable";
import { StyledMainDiv } from "Pages/MyBatchesAntd/MyBatchesAntd";
import React, { useContext, useEffect, useState } from "react";
import {
  BASE_URL,
  FacultyPerformance,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import dayjs from "dayjs";
import useMasterContext from "Context/MasterContext";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import FacultyHealthHeader from "Pages/Faculties/FacultyHealthHeader";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
export const aggregatedorder: string[] = [
  "totalFacultiesCount",
  "markedLectures",
  "unmarkedLectures",
  "overAllRating",
  "totalFeedbacksCount",
  "classBehaviour",
  "teachingPace",
  "doubtResolution",
];
export const processResponseForCardData = (
  data: any,
  aggregatedData: any
): [] => {
  if (data !== null) {
    Object.keys(data).forEach((key) => {
      if (Object.hasOwnProperty.call(data, key)) {
        aggregatedData.push({
          label: key,
          value: key === "overAllRating" && data[key] === 0 ? "NA" : data[key],
        });
      }
    });
  }
  return aggregatedData;
};
const FacultiesRegions = () => {
  const { screen }: any = useWindowSize();
  const userInfo = useContext<any>(UserInfoContext);
  const ToastDispatch = useContext(ToastContextDispatch);
  const { masters } = useMasterContext();
  const [region, setRegion] = useState<any>([]);
  const { facultyPerformance } = useContext(FacultyPerformanceContext);
  const [open, setOpen] = useState<boolean>(false);
  const [filterState, setFilterState] = useState<any>({
    streamIds:
      userInfo?.userStreams && userInfo?.userStreams[0] != undefined
        ? userInfo?.userStreams[0]
        : null,
    chipFields: {},
  });
  const [sortOrder] = useState("ASC");
  const [sortColumn] = useState<any>("branchOrRegionName");
  const currentMonth = dayjs().startOf("month");
  const nextMonth = dayjs().endOf("month");
  const [dates, setDates] = useState<any>([currentMonth, nextMonth]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "50", "100"],
    showSizeChanger: true,
    current: 1,
    sortField: "branchOrRegionName",
    sortOrder: "ASC",
  });
  const [cardAggregatedData, setCardAggregatedData] = useState<any>(null);
  useEffect(() => {
    const dashboardViewEvent = {
      event: "ag_fp_view_faculty_performance_dashboard",
      USER_ROLE: userInfo?.role ?? "",
      TARGET_MONTH: returnDateString(dates[0]),
      STREAM: filterState?.streamIds?.label ?? filterState?.streamIds ?? "",
    };
    pushToDataLayerForGTM(dashboardViewEvent);
  }, []);

  const { makeRequest: GetBranchData, loading: tableloading } = useGetApi(
    (data) => {
      if (
        data["data"] &&
        data["data"] &&
        data["data"]["facultyFeedbackResponse"]
      ) {
        setOpen(false);
        setRegion(data["data"]["facultyFeedbackResponse"]);
        setPagination({
          ...pagination,
          total: data?.totalCount,
        });
        const aggredatedDataList = data["data"]["facultyOverAllCardDetails"];
        const reorderedData: DataObject = {};
        aggregatedorder.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(aggredatedDataList, key)) {
            reorderedData[key] = aggredatedDataList[key];
          }
        });
        setCardAggregatedData(reorderedData);
      } else {
        setRegion([]);
      }
    },
    (error) => {
      setRegion([]);
      setOpen(false);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const applyFilter = (filterStateObj: any) => {
    const limit = pagination.pageSize;
    const offset = (pagination.current - 1) * pagination.pageSize;
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        streamIds: filterStateObj.streamIds
          ? filterStateObj.streamIds.value
          : masters.streams[0].value,
        subject: filterStateObj.subject?.value,
        branch: filterStateObj.branch?.map((item: any) => item.id)?.toString(),
        yearMonth:
          filterStateObj.yearMonth && filterStateObj.yearMonth.length > 0
            ? getMonthsBetweenDates(
                filterStateObj.yearMonth[0],
                filterStateObj.yearMonth[1]
              )
            : returnDateString(dates[0]),
      };
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + FacultyPerformance;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
      } else {
        url = url + "?";
      }
      url =
        url +
        "&sortBy=" +
        pagination.sortField +
        "&sortDir=" +
        pagination.sortOrder;
      if (location.pathname.includes("regions")) {
        url = url + "&fetchAllRegions=true";
      } else {
        const regionId =
          location.pathname.split("/")[location.pathname.split("/").length - 1];
        url = url + `&regionCode=${regionId}`;
      }
      GetBranchData(`${url}&limit=${limit}&offset=${offset}`);
    }
  };
  useEffect(() => {
    const offset = (pagination.current - 1) * pagination.pageSize;
    const limit = pagination.pageSize;
    const filterLength = Object.values(filterState).filter(
      (ele) => ele != null
    ).length;
    if (Object.keys(facultyPerformance).length) {
      applyFilter(facultyPerformance);
    } else {
      if (masters.streams && masters.streams[0] != undefined) {
        const streamId = masters.streams[0]?.value;
        let url =
          BASE_URL +
          FacultyPerformance +
          "?sortBy=" +
          pagination.sortField +
          "&sortDir=" +
          pagination.sortOrder;
        url = url + "&fetchAllRegions=true";
        if (filterLength) {
          applyFilter(filterState);
        } else {
          GetBranchData(
            `${url}&limit=${limit}&offset=${offset}&streamIds=${streamId}&yearMonth=${returnDateString(
              dates[0]
            )}`
          );
        }
      }
    }
  }, [
    masters.streams,
    sortColumn,
    sortOrder,
    pagination.current,
    pagination.pageSize,
    pagination.sortOrder,
  ]);
  useEffect(() => {
    if (Object.keys(facultyPerformance).length) {
      setFilterState({
        ...filterState,
        streamIds: facultyPerformance?.streamIds,
        yearMonth: facultyPerformance?.yearMonth,
        chipFields: {
          streamIds: facultyPerformance?.streamIds,
          yearMonth: facultyPerformance?.yearMonth,
        },
      });
      setDates(facultyPerformance?.yearMonth);
    } else {
      setFilterState({
        streamIds:
          userInfo?.userStreams && userInfo?.userStreams[0] != undefined
            ? userInfo?.userStreams[0]
            : null,
        yearMonth: dates,
        chipFields: {
          streamIds:
            userInfo?.userStreams && userInfo?.userStreams[0] != undefined
              ? userInfo?.userStreams[0]
              : null,
          yearMonth: dates,
        },
      });
    }
  }, [masters.streams, facultyPerformance]);

  return (
    <StyledMainDiv screen={screen}>
      <FacultiesRegionsHeader
        setFilterState={setFilterState}
        filterState={filterState}
        applyFilter={applyFilter}
        open={open}
        setOpen={setOpen}
        dates={dates}
        setDates={setDates}
      />
      <FacultyHealthHeader
        mode="regionFaculties"
        aggregatedDataLoading={tableloading}
        aggregatedData={processResponseForCardData(cardAggregatedData, [])}
      />
      <TableLayoutAntd isLoader={tableloading}>
        <FacultiesRegionsTable
          data={region}
          pagination={pagination}
          setPagination={setPagination}
          mode="Region"
        />
      </TableLayoutAntd>
    </StyledMainDiv>
  );
};

export default FacultiesRegions;
